module.exports = __webpack_public_path__ + "static/media/drop.698a6f5c.svg";